<template>
  <drag-dialog
    :append-to-body="true"
    :show.sync="dialog"
    :title="isAdd ? '新增职级' : '编辑职级'"
    :enableDrag="true"
    width="500px"
    @close="cancel"
  >
    <dynamic-form
      :formConfig="formConfig"
      v-model="form"
      @submit="doSubmit"
      @cancelForm="cancel"
      ref="pageForm"
      v-loading="initloading"
    ></dynamic-form>
  </drag-dialog>
</template>

<script>
import { addRank, edit } from "@/api/basic/rank.js";
import DragDialog from "@/components/DragDialog";
import "@/components/dynamic-form";
import { deepClone } from "@/utils/index";
export default {
  props: {
    isAdd: {
      type: Boolean,
      required: true
    },
    supThis: {
      type: Object
    }
  },
  components: {
    DragDialog
  },
  data() {
    return {
      initloading: false,
      loading: false,
      dialog: false,
      form: {},
      formConfig: {
        formItemList: [
          {
            type: "input",
            key: "code",
            maxlength: "50",
            label: "职级代码",
            placeholder: "请输入代码",
            rules: [
              { required: true, message: "不能为空", trigger: "blur" },
              {
                pattern: "^[^\u4e00-\u9fa5]{0,}$",
                message: "职级代码不能含有中文",
                trigger: "blur"
              },

            ]
          },
          {
            type: "input",
            key: "name",
            maxlength: "100",
            label: "职级名称",
            placeholder: "请输入名称",
            rules: [{ required: true, message: "不能为空", trigger: "blur" }]
          },
          {
            label: "技能类型",
            key: "skillsTypeObj",
            type: "databox",
            props: {
              label: "name",
              value: ""
            },
            url: "/bsSkillsType/findList",
            tableColumn: [
              {
                property: "code",
                label: "编码",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,code,name" },
            multiple: false,
            rules: [
              {
                required: true,
                message: "不能为空",
                trigger: "change"
              }
            ]
          },
          {
            label: "结算单价",
            type: "number",
            key: "settlementUnitPrice",
            value: "",
            rules: [
              { required: true, message: "请输入结算单价", trigger: "blur" }
            ]
          },
          {
            type: "textarea",
            maxlength: "200",
            showWordLimit: true,
            validateEvent: true,
            key: "remark",
            label: "备注",
            value: "",
            placeholder: "请输入备注"
          }
        ]
      }
    };
  },
  methods: {
    cancel() {
      this.resetForm();
    },
    doSubmit(val) {
      this.form = val;
      // console.log("form", this.form);
      const data = deepClone(this.form);
      if (data.skillsTypeObj) {
        data.skillsType = data.skillsTypeObj.name;
      }
      if (this.isAdd) {
        this.doAdd(data);
      } else this.doEdit(data);
    },
    doAdd(data) {
      addRank(data)
        .then(res => {
          this.resetForm();
          this.$notify({
            title: "添加成功",
            type: "success",
            duration: 2500
          });
          this.loading = false;
          this.supThis.dataTableInit();
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    doEdit(data) {
      edit(data)
        .then(res => {
          this.resetForm();
          this.$notify({
            title: "修改成功",
            type: "success",
            duration: 2500
          });
          this.loading = false;
          this.supThis.dataTableInit();
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    resetForm() {
      this.dialog = false;
      this.$refs.pageForm.resetForm();
      this.form = {}
    }
  }
};
</script>

<style scoped>
</style>
